export const SERVICES = [
  {
    slug: "google-my-business",
    title: "Google My Business Optimization",
    short: "Get found on Maps & Search — get started with ₹16/day.",
    iconKey: "MapPin",
    accent: "from-emerald-500/30 to-blue-500/10",
    iconColor: "text-emerald-400",
    pitch: "Dominate the local map pack so nearby customers find you first — for just ₹16/day.",
    deliverables: [
      "GMB profile setup, verification & optimization",
      "Geo-targeted posts and weekly updates",
      "Photo + video uploads optimized for search",
      "Review generation & response management",
      "Local citations and NAP consistency",
    ],
    outcomes: [
      "Top 3 map-pack visibility in your locality",
      "More 'Call' and 'Direction' actions",
      "Higher star rating and review count",
    ],
    image:
      "https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?auto=format&fit=crop&w=1100&q=80",
  },
  {
    slug: "paid-ads",
    title: "Paid Ads (Google & Meta)",
    short: "High-ROAS ad campaigns that convert clicks into customers.",
    iconKey: "Target",
    accent: "from-indigo-500/30 to-violet-500/10",
    iconColor: "text-indigo-400",
    pitch: "Performance campaigns engineered to deliver predictable ROI — not just impressions.",
    deliverables: [
      "Account structure & pixel/conversion setup",
      "Creative production: 6–20 ad variations / month",
      "Audience targeting & lookalike modeling",
      "Daily bid + budget optimization",
      "Transparent weekly ROAS reporting",
    ],
    outcomes: [
      "Predictable lead flow at a target CPL",
      "3x–5x return on ad spend (ROAS)",
      "Fast iteration based on real conversion data",
    ],
    image:
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1100&q=80",
  },
  {
    slug: "ai-ads",
    title: "AI Ads",
    short: "AI-generated creatives & copy that learn what converts.",
    iconKey: "Sparkles",
    accent: "from-fuchsia-500/30 to-purple-500/10",
    iconColor: "text-fuchsia-400",
    pitch: "Let AI generate, test and scale winning ad creatives — at a fraction of the time and cost.",
    deliverables: [
      "AI-generated ad creatives (images, video, copy)",
      "Automated A/B testing across 20+ variations / week",
      "Audience modeling powered by GenAI insights",
      "Real-time creative refresh to fight ad fatigue",
      "AI-driven bid + budget optimization",
    ],
    outcomes: [
      "10x faster creative iteration",
      "Lower CAC vs. manual ad ops",
      "Always-fresh creative library that compounds",
    ],
    image:
      "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=1100&q=80",
  },
  {
    slug: "android-app-development",
    title: "Android App Development",
    short: "Native and cross-platform Android apps built to scale.",
    iconKey: "Smartphone",
    accent: "from-emerald-500/30 to-teal-500/10",
    iconColor: "text-emerald-400",
    pitch: "Ship production-ready Android apps with clean code, modern UX and the Play Store guidelines baked in.",
    deliverables: [
      "User App with login authentication",
      "Admin dashboard",
      "Delivery boy / Admin app",
      "Playstore deployment",
    ],
    outcomes: [
      "App-store-ready APK / AAB delivered fast",
      "Smooth UX on low-end and high-end devices",
      "Higher install-to-active conversion",
    ],
    pricing: {
      total: "₹19,999",
      note: "Pay in 3 installments",
      firstInstallment: "₹6,666",
      paymentLink: "https://rzp.io/rzp/fmKRuhg",
      paymentLabel: "Start now",
      bullets: [
        "26+ years experience",
        "24/7 support",
        "Sprint 1 development",
      ],
    },
    image:
      "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=1100&q=80",
  },
  {
    slug: "website-development",
    title: "Website Development",
    short: "Fast, conversion-focused websites built to close the sale.",
    iconKey: "Globe",
    accent: "from-cyan-500/30 to-blue-500/10",
    iconColor: "text-cyan-400",
    pitch: "Modern, SEO-friendly websites engineered for speed, design and conversions.",
    deliverables: [
      "Custom Figma design & responsive build",
      "Next.js / React stack with CMS option",
      "On-page SEO and schema markup",
      "Core Web Vitals: 90+ Lighthouse score",
      "Hosting, analytics & launch support",
    ],
    outcomes: [
      "Higher search rankings and organic traffic",
      "2x–3x conversion vs old website",
      "Faster load times and better UX",
    ],
    image:
      "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?auto=format&fit=crop&w=1100&q=80",
  },
];

export const getServiceBySlug = (slug) => SERVICES.find((s) => s.slug === slug);
